import branchIO from "web/script/embedded/branch-io";
import environment from "web/script/modules/environment";
import {
    getBranchAnalyticsName,
    getLinkData,
    getBranchMetadata,
    shouldSendAnalytics,
} from "web/script/utils/branch-io";

export default {
    send(data) {
        data.forEach((event) => {
            if (event.type === "page_view") {
                branchIO("init", environment.get("branchIoKey"), {
                    // metadata is used for targeting journeys in branch.io dashboard
                    metadata: getBranchMetadata(event),
                });

                // Data that is passed through with click & view analytics
                branchIO("setBranchViewData", { data: getLinkData() });
            } else if (shouldSendAnalytics(event)) {
                return new Promise((resolve, reject) => {
                    branchIO("logEvent", getBranchAnalyticsName(event), null, function(err) {
                        if (err) {
                            reject(err);
                            return;
                        }
                        resolve();
                    });
                });
            }
        });
        // no way of waiting for this to be done
        return Promise.resolve();
    },
};
